module.exports = __webpack_public_path__ + "img/undertakingCases17.eb1667a2.jpg";